import { apiCall } from '../utils/apiUtils';

const API_BASE_URL = 'https://a3d1kmonz2.execute-api.us-east-1.amazonaws.com/dev';

export interface RatingData {
  outfitId: string;
  rating: number;
  comment?: string;
}

export interface RatingResponse {
  success: boolean;
  averageRating: number;
  totalRatings: number;
  userRating?: number;
}

export const rateOutfit = async (ratingData: RatingData): Promise<RatingResponse> => {
  try {
    const response = await apiCall<any>(`${API_BASE_URL}/outfits/${ratingData.outfitId}/ratings`, {
      method: 'POST',
      data: ratingData
    });
    
    // Backend wraps response as { success, message, data: { newAverageRating, totalRatings, ... } }
    // Normalize to the RatingResponse shape the frontend expects
    const data = response?.data || response;
    return {
      success: data?.success ?? response?.success ?? true,
      averageRating: data?.newAverageRating ?? data?.summary?.averageRating ?? 0,
      totalRatings: data?.totalRatings ?? data?.summary?.totalRatings ?? 0,
      userRating: ratingData.rating,
    };
  } catch (error) {
    console.error('Error rating outfit:', error);
    throw error;
  }
};

export const getOutfitRating = async (outfitId: string): Promise<RatingResponse> => {
  try {
    const response = await apiCall<RatingResponse>(`${API_BASE_URL}/outfits/${outfitId}/ratings`);
    return response;
  } catch (error) {
    console.error('Error fetching outfit rating:', error);
    return {
      success: false,
      averageRating: 0,
      totalRatings: 0
    };
  }
};

export const getUserRating = async (outfitId: string, userId: string): Promise<number | null> => {
  try {
    const response = await apiCall<{ rating: number }>(`${API_BASE_URL}/outfits/${outfitId}/ratings/user`);
    return response.rating || null;
  } catch (error) {
    console.error('Error fetching user rating:', error);
    return null;
  }
};

export const deleteRating = async (outfitId: string): Promise<boolean> => {
  try {
    await apiCall<void>(`${API_BASE_URL}/outfits/${outfitId}/ratings`, {
      method: 'DELETE'
    });
    return true;
  } catch (error) {
    console.error('Error deleting rating:', error);
    return false;
  }
};

// Legacy class export for compatibility
export class RatingService {
  static rateOutfit = rateOutfit;
  static getOutfitRating = getOutfitRating;
  static getUserRating = getUserRating;
  static deleteRating = deleteRating;
}
